<template>
  <div>
    <div class="d-flex align-center mb-4 h-35px px-1">
      <b-button-group class="ml-auto mb-4">
        <button @click="addRule" class="btn btn-info">
          <b-icon-plus-circle-fill /> Add Service
        </button>
      </b-button-group>
    </div>
    <template v-for="(item, index) in currentQuery">
      <Action
        :rule="item"
        :options="options"
        :operators="operators"
        :key="index"
        class="mt-2 px-1"
        ref="action"
      />
    </template>
  </div>
</template>

<script>
import Action from "@/own/components/customers/clients/actionBuilder/Action.vue";
export default {
  name: "ActionGroup",
  components: { Action },
  props: {
    currentQuery: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
    },
    operators: {
      type: Object,
      required: true,
    },
  },
  mounted: function () {
    this.$nextTick(() => {
      if (this.currentQuery.length === 0) {
        this.addRule();
      }
    });
  },
  methods: {
    addRule() {
      const newGroup = {
        type_id: this.options[0].id,
        options: [],
        condition: null,
      };
      this.currentQuery.push(newGroup);
      this.$nextTick(() => {
        this.$refs.action.forEach((comp) => {
          comp.$v.$touch();
        });
      });
    },
  },
};
</script>
